function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { AdditionalColors } from "../fundations/palette/colors";
import { getBackgroundToken, getChipToken } from "../fundations/palette/colorTokens";
import { Corner4 } from "../fundations/shape/corners";
export const Badge = {
    MuiBadge: {
        defaultProps: {
            max: 99,
            variant: "standard",
            anchorOrigin: {
                vertical: "top",
                horizontal: "left"
            }
        },
        styleOverrides: {
            root: ({ theme })=>({
                    "& .MuiBadge-badge": _object_spread_props(_object_spread({
                        padding: theme.spacing(0, 0.5),
                        borderRadius: Corner4,
                        alignItems: "center",
                        fontWeight: 600
                    }, theme.typography.text2xs), {
                        lineHeight: 0,
                        height: 16,
                        minWidth: 16
                    }),
                    "& .MuiBadge-dot": {
                        height: 8,
                        minWidth: 8,
                        borderRadius: "50%",
                        boxShadow: `0 0 0 2px ${getBackgroundToken("backgroundPrimaryBase", theme)}`,
                        background: AdditionalColors.radicalred[500],
                        "&.MuiBadge-anchorOriginTopLeft": {
                            top: 2,
                            left: 3
                        },
                        "&.MuiBadge-anchorOriginTopRight": {
                            top: 2,
                            right: 3
                        },
                        "&.MuiBadge-anchorOriginBottomLeft": {
                            bottom: 2,
                            left: 3
                        },
                        "&.MuiBadge-anchorOriginBottomRight": {
                            bottom: 2,
                            right: 3
                        }
                    }
                })
        },
        variants: [
            {
                props: {
                    color: "neutral"
                },
                style: ({ theme })=>({
                        "& .MuiBadge-badge": {
                            backgroundColor: getChipToken("neutral", theme),
                            color: getChipToken("neutralText", theme)
                        }
                    })
            },
            {
                props: {
                    color: "primary"
                },
                style: ({ theme })=>({
                        "& .MuiBadge-badge": {
                            backgroundColor: getChipToken("primary", theme),
                            color: getChipToken("primaryText", theme)
                        }
                    })
            },
            {
                props: {
                    color: "error"
                },
                style: ({ theme })=>({
                        "& .MuiBadge-badge": {
                            backgroundColor: getChipToken("error", theme),
                            color: getChipToken("errorText", theme)
                        }
                    })
            },
            {
                props: {
                    color: "success"
                },
                style: ({ theme })=>({
                        "& .MuiBadge-badge": {
                            backgroundColor: getChipToken("success", theme),
                            color: getChipToken("successText", theme)
                        }
                    })
            },
            {
                props: {
                    color: "warning"
                },
                style: ({ theme })=>({
                        "& .MuiBadge-badge": {
                            backgroundColor: getChipToken("warning", theme),
                            color: getChipToken("warningText", theme)
                        }
                    })
            }
        ]
    }
};

//# sourceMappingURL=Badge.js.map